import React, { useEffect, useState } from 'react';
import ArrowLeftCircle from '@jda/lui-common-icon-library/ui/ArrowLeftCircle';
import ArrowRightCircle from '@jda/lui-common-icon-library/ui/ArrowRightCircle';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import './Carousel.css';

const useStyles = makeStyles(theme => ({
  largeButton: {
    '&:hover': {
      color: 'black'
    }
  }
}));

export const CarouselItem = ({ children, width }: any) => {
  return (
    <div className="carousel-item" style={{ width: width }}>
      {children}
    </div>
  );
};

const Carousel = ({ children }: any) => {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndex = (newIndex: React.SetStateAction<number>) => {
    if (newIndex < 0) {
      newIndex = React.Children.count(children) - 1;
    } else if (newIndex >= React.Children.count(children)) {
      newIndex = 0;
    }
    setActiveIndex(newIndex);
  };
  let displayArrows = false;
  React.Children.map(children, (child, index) => {
    if (index >= 1) displayArrows = true;
  });
  return (
    <React.Fragment>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {displayArrows && (
          <ArrowLeftCircle
            fontSize="large"
            className={classes.largeButton}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              updateIndex(activeIndex - 1);
            }}
          />
        )}

        <div className="carousel">
          <div>
            <div className="inner" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
              {React.Children.map(children, (child, index) => {
                return React.cloneElement(child, { width: '100%' });
              })}
            </div>
          </div>
        </div>
        {displayArrows && (
          <ArrowRightCircle
            fontSize="large"
            className={classes.largeButton}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              updateIndex(activeIndex + 1);
            }}
          />
        )}
      </div>
      <div className="indicators">
        {React.Children.map(children, (child, index) => {
          return (
            <Box className="dot">
              <span
                key={`dot-${index}`}
                className={`${index === activeIndex ? 'active' : ''}`}
                onClick={() => {
                  updateIndex(index);
                }}
                style={{
                  marginLeft: '5px',
                  cursor: 'pointer',
                  color: activeIndex === index ? 'black' : 'pink',
                  textShadow: '0 3px 3px mistyrose'
                }}
              >
                &#9679;
              </span>
            </Box>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default Carousel;
